import Swiper from 'swiper/bundle';

/**
 * Export default article slider
 */
export default () => {
  function init() {
    const target = '#best-sellers-collection';
    new Swiper(target, {
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next--best-sellers',
        prevEl: '.swiper-button-prev--best-sellers',
      },
      pagination: {
        el: '.swiper-pagination--best-sellers',
        type: 'bullets',
        clickable: 'true',
      },
      breakpoints: {
        300: {
          slidesPerView: 2,
          spaceBetween: 5,
          centeredSlides: false,
          centeredSlidesBounds: true,
          freeModeSticky: true,
        },
        440: {
          slidesPerView: 2,
          spaceBetween: 5,
          centeredSlides: false,
        },
        767: {
          slidesPerView: 3,
          spaceBetween: 20,
          centeredSlides: false,
        },
        822: {
          slidesPerView: 4,
          spaceBetween: 25,
          centeredSlides: false,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 50,
          centeredSlides: false,
        },
      },
    });
  }

  /**
   * Return immutable object.
   */
  return Object.freeze({
    init,
  });
};
